import React from 'react';
import { FormattedMessage } from 'react-intl';

const TrustedElements = () => (
    <div className="cart__trusted pt-5 mb-4">
        <div className="row">
            <div className="col-lg-4">
                <div className="trusted-element trusted-element--1">
                    <p className="trusted-element__title"><FormattedMessage id='tickers_are_checked' /></p>
                    <p className="trusted-element__desk"><FormattedMessage id='antifraud_sistem' /></p>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="trusted-element trusted-element--2">
                    <p className="trusted-element__title"><FormattedMessage id='secured_transactions'/></p>
                    <p className="trusted-element__desk"><FormattedMessage id='secure_payments'/></p>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="trusted-element trusted-element--3">
                    <p className="trusted-element__title"><FormattedMessage id='buyer_guarantee'/></p>
                    <p className="trusted-element__desk"><FormattedMessage id='get_the_ordered_tickets'/></p>
                </div>
            </div>
        </div>

    </div>
);

export default TrustedElements;
